function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 12a5 5 0 100-10 5 5 0 000 10z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 14.5c-5.01 0-9.09 3.36-9.09 7.5 0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.77 20.68l-.76-.76c.4-.6.63-1.32.63-2.09a3.82 3.82 0 10-3.82 3.82c.77 0 1.49-.23 2.09-.63l.76.76c.15.15.35.23.55.23.2 0 .4-.08.55-.23.31-.31.31-.8 0-1.1z"
})));